module.exports = __webpack_public_path__ + "img/img_021@2x.dfdf6359.png";